import superAdminApi from "./superAdminApi";

const extractData = (res) => res?.data?.data ?? res?.data ?? null;

const extractMessage = (err, fallback) =>
  err?.response?.data?.message || err?.response?.data?.error || err?.message || fallback;

export async function fetchPlatformModules() {
  const res = await superAdminApi.get("/super-admin/platform-modules");
  return extractData(res)?.modules ?? [];
}

export async function updatePlatformModule(id, body) {
  const res = await superAdminApi.patch(`/super-admin/platform-modules/${id}`, body);
  return extractData(res)?.module ?? null;
}

export async function fetchPlatformSettings() {
  const res = await superAdminApi.get("/super-admin/platform-settings");
  return extractData(res)?.settings ?? [];
}

export async function updatePlatformSetting(id, settingValue) {
  const res = await superAdminApi.patch(`/super-admin/platform-settings/${id}`, {
    setting_value: settingValue,
  });
  return extractData(res)?.setting ?? null;
}

export { extractMessage as platformManagementExtractMessage };
